import React, { useContext, useState } from "react";
import "./loginPage.scss";
// import pgimage from "../../img/wallp.avif";
import { Link, useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { MdLock } from "react-icons/md";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { dispatch } = useContext(AuthContext);

  const loginAccount = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });

    try {
      setLoading(true);
      const response = await axios.post(`/login-admin`, {
        email,
        password,
      });

      if (response.data.success) {
        dispatch({ type: "LOGIN_SUCCESS", payload: response.data.user });
        navigate("/dashboard");
      } else {
        dispatch({ type: "LOGIN_FAILURE", payload: "Invalid credentials" });
        setErrorMsg("Incorrect password. Please try again.");
      }
    } catch (error) {
      dispatch({
        type: "LOGIN_FAILURE",
        payload:
          error.response?.data?.message || "Login failed. Please try again.",
      });
      setErrorMsg("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-right">
        <div></div>
        <form className="login-form" onSubmit={loginAccount}>
          <div className="log_hed">
            <h2>
              Admin <em>Login</em>
            </h2>
            {/* <h5>Teacher Portal</h5> */}
          </div>

          <div className="form-group">
            <label>Username</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@test.com"
              autoComplete="off"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="*******"
              autoComplete="off"
            />
          </div>
          {loading ? (
            <button className="login-btn">Please wait...</button>
          ) : (
            <button type="submit" className="login-btn">
              Login
            </button>
          )}

          {errorMsg && (
            <small
              style={{ fontSize: "10px", color: "red", marginTop: "10px" }}
            >
              {errorMsg}
            </small>
          )}
        </form>
        <div className="copy_right">
          <small>Copyright © Notions Group. All Rights Reserved.</small>
        </div>
      </div>
      <div
        className="login-left"
        // style={{
        //   backgroundImage: `url(${pgimage})`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "left",
        //   objectFit: "contain",
        // }}
      >
        <div className="branding">
          {/* <h1>
            Welcome to <em> Mentora.lk</em>{" "}
          </h1>

          <h5>Learn Smarter. Grow Stronger</h5> */}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
